/* eslint-disable graphql/template-strings */
import React, {PureComponent} from "react"
import {Query as QueryComponent} from "@irati/utils/services/apollo"
import {Query, QueryResult} from "@irati/utils/apollo"
import partialUser from "@irati/identity/services/fragments/PartialUser"
import {gql} from "@irati/utils/gql"
import {PollList} from "@irati/types"
import PollFragment from "../fragments/Poll"

const query = gql`
  query ClosedPolls($cursor: String, $limit: Int) {
    closedPolls(cursor: $cursor, limit: $limit) @connection(key: "closed_polls") {
      results {
        ...Poll
      }
      count
      cursor
    }
  }
  ${PollFragment}
  ${partialUser}
`

export interface ClosedPollsVariables {
  limit: number
  cursor: number
}

interface ClosedPollsData {
  closedPolls: PollList
}

export type ClosedPolls = QueryResult<ClosedPollsData, ClosedPollsVariables>

interface Props {
  variables?: ClosedPollsVariables
  useError?: boolean
  useLoader?: boolean
}

const variables = {
  limit: 10,
  cursor: null
}

// @todo used by web
// Once web is refactored to use QueryComponent delete this
export const closedPollsQuery = {
  query,
  variables
}

class TypedQuery extends Query<ClosedPolls> {}

export default class ClosedPollsQuery extends PureComponent<Props> {
  static defaultProps = {
    variables,
    useError: true,
    useLoader: true
  }

  render() {
    return <QueryComponent {...this.props} query={query} QueryComponent={TypedQuery} notifyOnNetworkStatusChange />
  }
}
